import { render } from "./ModalBoat.vue?vue&type=template&id=5c5598d0&lang=pug"
import script from "./ModalBoat.vue?vue&type=script&lang=js"
export * from "./ModalBoat.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__